import { render, staticRenderFns } from "./trendSecond.vue?vue&type=template&id=d46c7e58&"
import script from "./trendSecond.vue?vue&type=script&lang=js&"
export * from "./trendSecond.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports